import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer'
import { useEntity, useMeta } from '@uswitch/ev-utils/context/selectors'

const Review = ({ sys }) => {
  const { authorName: name, rating: ratingValue, review } = useEntity(sys)

  return {
    '@type': 'Review',
    reviewRating: {
      '@type': 'Rating',
      ratingValue
    },
    author: {
      '@type': 'Person',
      name
    },
    reviewBody: documentToPlainTextString(review)
  }
}

const AggregateRating = () => {
  // TODO: get the rating via the trustpilot API
  const { aggregateRating: ratingValue, ratingCount } = useMeta(['reviews']) || {
    aggregateRating: 5,
    ratingCount: 0
  }

  return {
    '@type': 'AggregateRating',
    ratingValue,
    bestRating: '5',
    ratingCount
  }
}

const productSchema = (includes, embeddedEeveeEntityIds) => {
  const reviews = includes[embeddedEeveeEntityIds?.reviews]?.fields?.entries || []
  const metaTitle = includes[embeddedEeveeEntityIds?.modularPage]?.fields?.title || ''

  // get the offer price from the meta title if present, otherwise default to 18
  const STATIC_PRICE = 18
  const metaTitleMatch = metaTitle?.match(/£(\d+)/)
  const lowPrice = metaTitleMatch ? parseInt(metaTitleMatch[1]) : STATIC_PRICE

  return JSON.stringify({
    '@context': 'http://schema.org',
    '@type': 'Product',
    brand: {
      '@type': 'Brand',
      name: 'Uswitch'
    },
    name: 'Broadband Deals',
    image:
      'https://img.uswitch.com/n36b8lzdmgnp/79Z7BKkwi4aZL6kFuhHlJl/b8a4a159eaa932a13d40f843e683b5bf/router-sticker.jpg',
    offers: {
      '@type': 'AggregateOffer',
      priceCurrency: 'GBP',
      lowPrice,
      availability: 'http://schema.org/InStock'
    },
    aggregateRating: AggregateRating(),
    reviews: reviews.map(Review)
  })
}

export default productSchema
